// src/components/AssignProgramModal.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-hot-toast';

const AssignProgramModal = ({ client, onClose, onProgramAssigned }) => {
  const [programs, setPrograms] = useState([]);
  const [selectedProgramId, setSelectedProgramId] = useState('');
  const [startDate, setStartDate] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // Cargar la lista de programas disponibles cuando el modal se abre
  useEffect(() => {
    const fetchPrograms = async () => {
      const token = localStorage.getItem('token');
      try {
        const response = await axios.get('http://127.0.0.1:8000/programs', {
          headers: { Authorization: `Bearer ${token}` }
        });
        setPrograms(response.data);
      } catch (err) {
        setError('No se pudieron cargar los programas.');
      } finally {
        setLoading(false);
      }
    };
    fetchPrograms();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedProgramId || !startDate) {
      setError('Por favor, selecciona un programa y una fecha de inicio.');
      return;
    }
    setLoading(true);
    setError('');
    const token = localStorage.getItem('token');
    try {
      await axios.post(
        `http://127.0.0.1:8000/admin/clients/${client.id}/assign-program`,
        { program_id: parseInt(selectedProgramId), start_date: startDate },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success('Programa asignado con exito.');
      onProgramAssigned(); // Llama a la función del padre
      onClose();
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al asignar el programa.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/75 backdrop-blur-sm flex justify-center items-center z-50 p-4">
      <div className="glass-panel p-8 rounded-xl shadow-xl w-full max-w-lg animate-fade-up">
        <h2 className="text-2xl font-bold text-white mb-6">Asignar Programa a {client.name}</h2>
        {loading && <p className="text-white">Cargando programas...</p>}
        {!loading && (
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="program-select" className="block text-sm font-medium text-gray-300">Programa de Entrenamiento</label>
              <select
                id="program-select"
                value={selectedProgramId}
                onChange={(e) => setSelectedProgramId(e.target.value)}
                required
                className="mt-1 block w-full p-3 bg-gray-700 text-white font-bold rounded-md border-gray-600 focus:ring-marizan-red focus:border-marizan-red"
              >
                <option value="">Selecciona un programa...</option>
                {programs.map(p => (
                  <option key={p.id} value={p.id}>{p.name}</option>
                ))}
              </select>
            </div>
            <div>
              <label htmlFor="start-date" className="block text-sm font-medium text-gray-300">Fecha de Inicio</label>
              <input
                type="date"
                id="start-date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                required
                className="mt-1 block w-full p-3 bg-gray-700 text-white font-bold rounded-md border-gray-600 focus:ring-marizan-red focus:border-marizan-red"
              />
            </div>
            {error && <p className="text-red-300 bg-red-950/40 border border-red-900/60 rounded-lg px-3 py-2 text-sm text-center">{error}</p>}
            <div className="flex justify-end space-x-4 pt-4">
              <button type="button" onClick={onClose} className="bg-gray-600 hover:bg-gray-500 text-white font-bold py-2 px-4 rounded-lg">Cancelar</button>
              <button type="submit" disabled={!selectedProgramId || !startDate} className="bg-marizan-red hover:bg-red-700 text-white font-bold py-2 px-4 rounded-lg disabled:opacity-50">Asignar</button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default AssignProgramModal;